import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  xValue?: number;
  yValue?: number;
}

export const Root = styled.div`
`

export const AuxText = styled.div`
  position: absolute;
  left: ${(props: IProps) => (props.xValue ? `${props.xValue - 194}px` : `auto`)};
  top: ${(props: IProps) => (props.yValue ? `${props.yValue}px` : `auto`)};
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
  width: 194px;
  height: 35px;
  border-radius: 2px;
  background-color: rgba(18, 36, 66, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const MenuContainer = styled.div`
  position: absolute;
  left: ${(props: IProps) => (props.xValue ? `${props.xValue - 194}px` : `auto`)};
  top: ${(props: IProps) => (props.yValue ? `${props.yValue}px` : `auto`)};
  width: 323px;
  padding: 25px 0px;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: ${C.WHITE};
`

export const MenuTitle = styled.div`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  padding: 0px 30px;
  color: ${C.DARK_BLUE};
`

export const MenuSubtitle = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  padding: 14px 30px;
  color: rgba(32, 64, 120, 0.5);
`

export const MenuDivider = styled.div`
  width: calc(100% - 60px);
  height: 1px;
  margin: 14px 30px;
  background-color: rgba(32, 64, 120, 0.2);
`

export const MenuActionContainer = styled.div`
`

export const MenuActionRow = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  height: 50px;
  padding: 0px 30px;
  &:hover {
    background-color: ${C.LIGHTEST_GRAY};
  }
`

export const MenuActionIcon = styled.div`
`

export const MenuAactionText = styled.div`
  padding-left: 23px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
`